// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_36lIh","item":"index_item_Md5MN","footer":"index_footer_l4LHc"};